<script>
export default {
  props: {
    path: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      items: [],
      filters: {},
      loading: false
    }
  },
  mounted() {
    this.getItems()
  },
  methods: {
    getItems() {
      this.loading = true
      this.$http.get(this.path + '?q=')
        .then((response) => this.items = response.data)
        .catch((error) => this.handleXhrError(error))
        .finally(() => this.loading = false)
    }
  }
}
</script>

<template>
  <a-card type="inner" size="small">
    <a-skeleton active :loading="loading">
      <a-tabs defaultActiveKey="driver-0" tabPosition="left">
        <a-tab-pane :key="`driver-${index}`" :tab="item.name" v-for="(item, index) in items">
          <json-source :source="item"/>
        </a-tab-pane>
      </a-tabs>
    </a-skeleton>
  </a-card>
</template>
